package com.nnod.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nnod.ui.theme.NnodInputSurface
import com.nnod.ui.theme.NnodPurpleDeep

@Composable
fun NnodDisplayCodeBox(
    code: String,
    modifier: Modifier = Modifier,
    accentColor: Color = NnodPurpleDeep,
    cellWidth: Dp = 34.dp,
    cellHeight: Dp = 44.dp,
    cellSpacing: Dp = 6.dp,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(cellSpacing, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        code.forEach { char ->
            Box(
                modifier = Modifier
                    .width(cellWidth)
                    .height(cellHeight)
                    .background(NnodInputSurface, RoundedCornerShape(9.dp))
                    .border(1.5.dp, accentColor.copy(alpha = 0.2f), RoundedCornerShape(9.dp)),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = char.toString(),
                    fontSize = 24.sp,
                    fontWeight = FontWeight.ExtraBold,
                    color = accentColor,
                    textAlign = TextAlign.Center,
                )
            }
        }
    }
}
